
import { Component, Vue, Prop } from 'vue-property-decorator';
// import draggable from 'vuedraggable';

@Component({
  name: 'OrderColumn',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({})
  })columnItemData!: [];

  private visiblePopover = false
  created() {

  }
  // private confirmHandle() {}
  // private settingLocal() {}
}
